import { AlignmentType, Document, Paragraph, TextRun } from "docx";

export class DocumentCreator {
  create(meeting, agendas) {
    const document = new Document({
      creator: "E-meeting",
      styles: {
        paragraphStyles: [
          {
            id: "docTitle",
            name: "Doc Title",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              bold: true,
              size: 34,
              italics: false,
              color: "black",
              font: "TH SarabunPSK"
            },
          },
          {
            id: "docBody",
            name: "Doc Body",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              bold: false,
              size: 32,
              italics: false,
              color: "black",
              font: "TH SarabunPSK"
            },
          },
          {
            id: "docBodyBold",
            name: "Doc Body Bold",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              bold: true,
              size: 32,
              italics: false,
              color: "black",
              font: "TH SarabunPSK"
            },
          },
        ],
      },
    })

    document.addSection({
      children: [
        new Paragraph({
          text: `ระเบียบวาระ${meeting.title}`,
          alignment: AlignmentType.CENTER,
          style: "docTitle",
        }),
        new Paragraph({
          text: meeting.year,
          alignment: AlignmentType.CENTER,
          style: "docTitle"
        }),
        new Paragraph({
          text: meeting.date,
          alignment: AlignmentType.CENTER,
          style: "docTitle"
        }),
        new Paragraph({
          text: meeting.location,
          alignment: AlignmentType.CENTER,
          style: "docTitle"
        }),
        new Paragraph({
          alignment: AlignmentType.CENTER,
          spacing: {
            after: 160
          }
        }),
        ...this.generateAgenda(agendas)
      ],
    });

    return document;
  }

  generateAgenda(agendas)  {
    let paragraphs = []

    agendas.map((agenda, index) => {
      paragraphs.push(
        new Paragraph({
          alignment: AlignmentType.Left,
          style: "docBodyBold",
          children: [
            new TextRun({
              text: `ระเบียบวาระที่ ${index + 1}`,
            }),
            new TextRun({
              text: `\t${agenda.title}`,
            })
          ]
        })
      )
        
      agenda.body.map(value => {
        paragraphs.push(
          new Paragraph({
            alignment: AlignmentType.Left,
            style: "docBody",
            text: value,
            indent: {
              left: 2166,
            }
          })
        )
      })
    })

    return paragraphs
  }
}